<template>
    <v-row no-gutters="true" dense="true" class="align-baseline">
        <v-col cols="2">
            <div class="h5">{{ service.toUpperCase() }}</div>
        </v-col>

        <v-col cols="3">
            <v-text-field
                :value="pharmacist"
                @input="$emit('update:pharmacist', $event)"
                placeholder="Freiberufler"
                label="Freiberufler"
                :name="`${service}-pharmacist`"
                type="number"
                min="0"
                :rules="pricingOverrideRules"
                prepend-icon="mdi-currency-eur"
            />
        </v-col>

        <v-col cols="3" class="ml-2">
            <v-text-field
                :value="margin"
                @input="$emit('update:margin', $event)"
                placeholder="Margin"
                label="Margin"
                :name="`${service}-margin`"
                type="number"
                min="0"
                :rules="pricingOverrideRules"
                prepend-icon="mdi-currency-eur"
            />
        </v-col>

        <v-col cols="3" class="ml-auto">
            <v-text-field
                :value="totalPrice"
                placeholder="Total price"
                label="Total price"
                type="number"
                :name="`${service}-pharmacy`"
                :rules="pricingOverrideRules"
                prepend-icon="mdi-currency-eur"
                readonly
                disabled
                filled
            />
        </v-col>
    </v-row>
</template>

<script>
export default {
    props: {
        service: String,
        pharmacist: Number,
        pharmacy: Number,
        margin: Number
    },
    data() {
        return {
            pricingOverrideRules: [(v) => (v === null || v === undefined || v >= 0)],
        }
    },
    computed: {
        totalPrice() {
            return +this.pharmacist + +this.margin || this.pharmacy
        }
    },
    watch: {
        totalPrice(total) {
            this.$emit('update:pharmacy', total)
        },
    },
}
</script>

<style></style>